<template>
  <div class="section-categories" :class="{ 'section-categories--list-layout': listLayout }">
    <ul class="section-categories__list">
      <li class="li" v-if="categories && categories.length" v-for="category in categories">
        <BaseLink class="category" :to="category.to">
          <div class="category__icon">
            <BaseIcon :name="category.icon"/>
          </div>

          <div class="category__text">
            <label>{{ category.name }} </label>

            <router-link class="edit-link-inner" v-if="category.editUrl && category.editUrlPlacement === 'inner'" :to="category.editUrl">Edit values</router-link>
          </div>

        </BaseLink>
        <router-link class="edit-link" v-if="category.editUrl && category.editUrlPlacement !== 'inner'" :to="category.editUrl">Edit values</router-link>
      </li>
      <li v-if="!categories || !categories.length">
        <h1 class="alert alert__title">You don’t have any custom objects yet</h1>
        <h2 class="alert alert__subtitle">Your custom objects will be shown here once you have created your first one.</h2>
      </li>
    </ul>
    <slot name="button"></slot>
  </div>
</template>

<script>
export default {
    props: {
        categories: Array,
        listLayout: Boolean
    }
}
</script>

<style lang="scss">
@import './src/assets/styles/colors.scss';
@import './src/assets/styles/breakpoints.scss';

.section-categories {
    width: 668px;
    background-color: $color-white;
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15);

    @include media(ltTablet) {
        width: 100%;
    }

    &:not(:last-of-type) {
        margin-bottom: 20px;
    }
}

.section-categories .new-field-button {
    border-right: none;
    border-bottom: none;
    border-left: none;
}

.section-categories__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px;

    li {
        width: 100%;
    }

    li.li {
        flex-shrink: 0;
        width: calc(50% - 10px);

        @include media(ltMobile) {
            width: 100%;
        }
    }

    .category {
        display: flex;
        align-items: center;
        padding: 12px;
        border-radius: 3px;

        &:hover {
            @include media(hover) {
                background-color: $color-athens-gray;

                .category__icon {
                    background-color: $color-geyser;
                }
            }
        }

        &:focus {
            outline: 2px solid $color-purple;
        }

        label {
            margin-left: 16px;
            font-size: 14.6px;
            font-weight: 600;
            cursor: pointer;
        }

        &__icon {
            padding: 10px;
            background-color: $color-athens-gray;
            border-radius: 3px;

            svg {
                width: 20px;
                height: 20px;
                color: $color-regent-gray;
            }
        }

        &__text {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
    }

    .alert {
        width: 100%;
        text-align: center;

        &__title {
            margin-top: 10px;
            color: $color-ebony-clay;
            font-size: 19px;
            font-weight: 500;
            line-height: 1.33;
        }

        &__subtitle {
            margin-top: 16px;
            margin-bottom: 10px;
            color: $color-pale-sky;
            font-size: 14.6px;
            line-height: 1.28;
        }
    }

    .edit-link-inner {
        font-size: 14.6px;
        color: $color-black;
        text-decoration: underline;

        &:hover {
            color: $color-lochmara;
        }
    }
}

.section-categories--list-layout {
    display: block;

    li.li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .category {
            width: calc(50% - 10px);
        }

        .edit-link {
            font-size: 14.6px;
            text-decoration: underline;

            &:hover {
                @include media(hover) {
                    text-decoration: none;
                }
            }

            &:focus {
                outline: 2px solid $color-purple;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionCategories.vue